import { useState } from "react";
import { Row, Container, Breadcrumb, Navbar } from "react-bootstrap";
import { connect } from "react-redux";
import { getDayOpenSaleReport } from "./Report.action";
import { Link } from "react-router-dom";
// import _ from "lodash";
import Swal from "sweetalert";
// import moment from "moment";
import IconMenu from "../../../drawer/IconMenu";
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';


const DateWiseSaleReport = (props) => {
  const [dangerVisibleAlert, setDangerVisibleAlert] = useState(false);

  const handleDangerVisible = () => {
    setDangerVisibleAlert(true);
    setTimeout(() => {
      setDangerVisibleAlert(false);
    }, 9000);
    Swal({
      title: "Error",
      text: "Something went Wrong!",
      icon: "error",
      button: "Ok",
    });
  };
  const exportPDF = () => {
    props.getDayOpenSaleReport(
      handleDangerVisible
    );
  };

  return (
    <>
      <Navbar style={{ backgroundColor: '#81abd3' }}  >
        <Container>
          <Navbar.Brand style={{ color: 'white' }}><b>Day Open Sale Report</b></Navbar.Brand>
          <IconMenu />
        </Container>
      </Navbar>

      <Container fluid>
        <div className="main">
          <Row>
            <Breadcrumb>
              <Breadcrumb.Item ><Link to="/home"> Home</Link></Breadcrumb.Item>
              <Breadcrumb.Item ><Link to="/report">Report</Link> </Breadcrumb.Item>
              <Breadcrumb.Item active>Day Open Sale Report</Breadcrumb.Item>
            </Breadcrumb>
          </Row>

          <div className="sendDiv">
            <Button variant="contained" endIcon={<SendIcon />} size="large" onClick={() => exportPDF()}> Generate Report </Button>
          </div>

        </div>
      </Container>
    </>
  );
};
const mapDispatchToProps = (dispatch) => {
  return {
    getDayOpenSaleReport: (handleDangerVisible) => dispatch(getDayOpenSaleReport(handleDangerVisible)),
  };
};
const mapStateToProps = (state, ownProps) => ({
  isFetchingDayOpenSaleReport: state.ReportReducer.isFetchingDayOpenSaleReport,
  dayOpenSaleReportData: state.ReportReducer.dayOpenSaleReportData,
});

export default connect(mapStateToProps, mapDispatchToProps)(DateWiseSaleReport);
